import { pickInboxSafetyLeader } from "./inbox-live-sync";

const CHANNEL_NAME = "fab-inbox-safety";

export type InboxSafetyLeader = {
  isLeader: () => boolean;
  close: () => void;
};

/**
 * Uma aba visível faz a checagem de segurança. As outras só escutam o tempo real.
 */
export function bindInboxSafetyLeader(tabId: string): InboxSafetyLeader {
  if (typeof BroadcastChannel === "undefined") {
    return { isLeader: () => true, close: () => {} };
  }

  const channel = new BroadcastChannel(CHANNEL_NAME);
  const peers = new Set<string>([tabId]);
  let leader = tabId;

  const recompute = () => {
    leader = pickInboxSafetyLeader([...peers]) ?? tabId;
  };

  const announce = () => {
    channel.postMessage({ type: "hello", tabId });
  };

  channel.onmessage = (event: MessageEvent) => {
    const data = event.data as { type?: string; tabId?: string } | null;
    if (!data || typeof data.tabId !== "string") return;
    if (data.type === "bye") {
      peers.delete(data.tabId);
      recompute();
      return;
    }
    if (data.type === "hello" || data.type === "ack") {
      peers.add(data.tabId);
      recompute();
      if (data.type === "hello") {
        channel.postMessage({ type: "ack", tabId });
      }
    }
  };

  announce();
  const beat = window.setInterval(announce, 15_000);

  return {
    isLeader: () => leader === tabId,
    close: () => {
      window.clearInterval(beat);
      try {
        channel.postMessage({ type: "bye", tabId });
      } catch {
        /* canal já fechado */
      }
      channel.close();
    },
  };
}
